import {of,  Observable } from 'rxjs';
import { TranslateLoader } from '@ngx-translate/core';

const en = require('../i18n/en.json');
const ru = require('../i18n/ru.json');
const cn = require('../i18n/cn.json');

export class CustomLoader implements TranslateLoader {
  getTranslation (lang: string): Observable<any> {
    switch (lang) {
      case 'en_US':
        return of(en);
      case 'ru_RU':
        return of(ru);
      case 'zh_CN':
        return of(cn);
      default:
        return of({});
    }
  }
}
